var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result-box"},[_c('img',{staticClass:"img-result",attrs:{"src":require("@/assets/images/unknow.png"),"width":"134"}}),_c('div',{staticClass:"margin-top-28 status"},[_vm._v(_vm._s(_vm.$t('message.result.invalid')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }